import React from 'react';
import { Link } from 'react-router-dom';

export default function PricesPracticalPage() {
  return (
    <>
      <title>Priser | rolskov-bowtech.dk</title>
      <meta
        name="description"
        content="Se priser og praktisk information for Bowtech-behandling i Skårup. 400 kr. pr. behandling af ca. 1 times varighed."
      />
      <link rel="canonical" href="https://rolskov-bowtech.dk/about%20us" />

      {/* Header Banner */}
      <section className="bg-[#f4efe6]/60 py-12 lg:py-16 border-b border-[#228A47]/10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 space-y-4">
          <span className="text-xs font-semibold text-[#228A47] uppercase tracking-wider bg-[#e8f5ed] px-3 py-1 rounded-full">
            Priser &amp; Praktisk
          </span>
          <h1 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-[#062364]">
            Priser &amp; Praktisk information
          </h1>
          <p className="text-base sm:text-lg text-[#132038] max-w-3xl leading-relaxed">
            Oversigt over priser, varighed og praktiske forhold i klinikken i Skårup.
          </p>
        </div>
      </section>

      {/* Content Grid */}
      <section className="py-16 bg-[#faf8f5]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 space-y-12">
          
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 items-start">
            
            {/* Price Box */}
            <div className="lg:col-span-6 bg-white p-8 lg:p-10 rounded-3xl border border-[#228A47]/15 shadow-xs space-y-6">
              <div className="space-y-1">
                <span className="text-xs font-semibold text-[#228A47] uppercase tracking-wider">
                  Enkel &amp; gennemskuelig pris
                </span>
                <h2 className="text-2xl font-bold text-[#062364]">
                  Pris for behandling
                </h2>
              </div>

              <div className="p-6 rounded-2xl bg-[#e8f5ed] border border-[#228A47]/20 flex flex-col sm:flex-row sm:items-center justify-between gap-3 sm:gap-0">
                <div>
                  <p className="text-lg font-bold text-[#062364]">Bowtech-behandling</p>
                  <p className="text-xs text-slate-600">Inkl. indledende samtale &amp; opfølgning</p>
                </div>
                <div className="text-left sm:text-right">
                  <p className="text-3xl font-extrabold text-[#228A47]">400 kr.</p>
                  <p className="text-xs text-slate-500">pr. behandling</p>
                </div>
              </div>

              <div className="space-y-3 text-sm text-[#132038] leading-relaxed">
                <p className="flex items-center gap-2.5">
                  <i className="fa-regular fa-clock text-[#228A47]" aria-hidden="true"></i>
                  <span><strong>Varighed:</strong> Ca. 1 time pr. behandling</span>
                </p>
                <p className="flex items-center gap-2.5">
                  <i className="fa-regular fa-shirt text-[#228A47]" aria-hidden="true"></i>
                  <span><strong>Påklædning:</strong> Kan udføres uden på tøjet</span>
                </p>
                <p className="flex items-center gap-2.5">
                  <i className="fa-regular fa-calendar-alt text-[#228A47]" aria-hidden="true"></i>
                  <span><strong>Aftale:</strong> Behandling sker efter aftale</span>
                </p>
              </div>

              <div className="pt-2">
                <a
                  href="tel:27117557"
                  className="whitespace-nowrap inline-flex items-center justify-center gap-2 w-full py-3.5 px-6 text-sm font-semibold text-white bg-[#228A47] hover:bg-[#1b713a] rounded-xl shadow-xs transition-colors"
                >
                  <i className="fa-solid fa-phone" aria-hidden="true"></i>
                  <span>Ring og bestil tid: 27 11 75 57</span>
                </a>
              </div>
            </div>

            {/* Practical Conditions */}
            <div className="lg:col-span-6 bg-[#f4efe6]/60 p-8 lg:p-10 rounded-3xl border border-[#228A47]/10 space-y-6">
              <div className="space-y-1">
                <span className="text-xs font-semibold text-[#228A47] uppercase tracking-wider">
                  Klinikadresse &amp; Betingelser
                </span>
                <h2 className="text-2xl font-bold text-[#062364]">
                  Find klinikken
                </h2>
              </div>

              <div className="space-y-4 text-sm text-[#132038] leading-relaxed">
                <div className="bg-white p-5 rounded-2xl border border-[#228A47]/10 space-y-2">
                  <p className="font-bold text-[#062364] flex items-center gap-2">
                    <i className="fa-regular fa-location-dot text-[#228A47]" aria-hidden="true"></i>
                    <span>Adresse:</span>
                  </p>
                  <p className="text-slate-700">
                    Østergade 47, 5881 Skårup Fyn
                  </p>
                </div>

                <div className="bg-white p-5 rounded-2xl border border-[#228A47]/10 space-y-2">
                  <p className="font-bold text-[#062364] flex items-center gap-2">
                    <i className="fa-regular fa-hand-holding-heart text-[#228A47]" aria-hidden="true"></i>
                    <span>Kombination med andre terapier:</span>
                  </p>
                  <p className="text-xs text-slate-600 leading-relaxed">
                    Andre former for manipulerende behandling udført op til 4 dage før og 5 dage efter en Bowtechbehandling forstyrrer dens effektivitet.
                  </p>
                </div>
              </div>

              <div className="pt-2">
                <Link
                  to="/contact"
                  className="inline-flex items-center justify-center gap-2 w-full py-3.5 px-6 text-sm font-semibold text-[#062364] bg-white hover:bg-[#e8f5ed] border border-[#228A47]/20 rounded-xl transition-colors"
                >
                  <span>Gå til kontaktsiden med kort</span>
                  <i className="fa-regular fa-arrow-right" aria-hidden="true"></i>
                </Link>
              </div>

            </div>

          </div>

        </div>
      </section>
    </>
  );
}
